import {
  createApdex,
  getApdex,
  getDataRetentionPolicy,
  createDataRetentionPolicy,
  getTransactionApplicationData,
  getTransactionEndpointData,
  getTransUpdateorDeleteApplData,
  getTransUpdateorDeleteEndpointData,
  queryValidationData,
  queryValidationStatus,
  saveQueryInfo,
  queryTableInfo,
  getRunQueryInfo,
  getAIEnableData,
  getInstancesList,
  enableCodeProfile,
  getCodeProfileInstance,
  deleteCodeProfile,
} from '../fragments/settings';

export const queryApdex = `query getApdex(${getApdex.variable}) {${getApdex.query}}`;

export const queryApdexMutation = `mutation createApdex(${createApdex.variable}) {${createApdex.query}}`;

export const queryDataRetentionConfig = `query getDataRetentionPolicy(${getDataRetentionPolicy.variable}) {${getDataRetentionPolicy.query}}`;

export const saveDataRetentionConfig = `mutation createDataRetentionPolicy(${createDataRetentionPolicy.variable}) {${createDataRetentionPolicy.query}}`;

export const getTransactionApplications = `query getAllApplications(${getTransactionApplicationData.variable}) {${getTransactionApplicationData.query}}`;

export const getTransactionEndpoints = `query getAllEndpoints(${getTransactionEndpointData.variable}) {${getTransactionEndpointData.query}}`;

export const mutateTransApplicationRule = `mutation mutateApplicationTransaction(${getTransUpdateorDeleteApplData.variable}) {${getTransUpdateorDeleteApplData.query}}`;

export const mutateTransEndpointRule = `mutation mutateEndpointTransaction(${getTransUpdateorDeleteEndpointData.variable}) {${getTransUpdateorDeleteEndpointData.query}}`;

export const mutateQueryValidation = `mutation validateQuery(${queryValidationData.variable}) {${queryValidationData.query}}`;

export const mutateQueryValidationStatus = `query dbmCustomQueryStatus(${queryValidationStatus.variable}) {${queryValidationStatus.query}}`

export const mutateSaveQueryInfo = `mutation validateQuery(${saveQueryInfo.variable}) {${saveQueryInfo.query}}`

export const displayQueryInfo = `query  displayQuery(${queryTableInfo.variable}) {${queryTableInfo.query}}`

export const runQueryInfo = `query runQuery(${getRunQueryInfo.variable}) {${getRunQueryInfo.query}}`

export const checkAIenabled = `query queryData(${getAIEnableData.variable}) {${getAIEnableData.query}}`;

export const queryGetInstances = `query readAggregatedScopedMetrics(${getInstancesList.variable}) {${getInstancesList.query}}`;

export const enableOrDeleteCodeProfileInstance = `mutation createOrUpdateProfile(${enableCodeProfile.variable}) {${enableCodeProfile.query}}`;

export const deleteCodeProfileInstance = `mutation deleteProfiling(${deleteCodeProfile.variable}) {${deleteCodeProfile.query}}`;

export const queryGetCodeProfileInstances = `query findCodeProfile(${getCodeProfileInstance.variable}) {${getCodeProfileInstance.query}}`;
